export default "__VITE_ASSET__Z27IwjgZ__"